import { useContext } from "react";

import {
  FALLBACK_TIME_CONTEXT,
  TimeContext,
  type TimeContextValue,
} from "./time-provider";

/**
 * The active time-zone context. Outside a `TimeProvider` this resolves to local
 * time, so component packages and tests can call it unconditionally.
 */
export function useTimezone(): TimeContextValue {
  return useContext(TimeContext) ?? FALLBACK_TIME_CONTEXT;
}
